

// Dropdown
export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_KNOWLEDGE = "GET_KNOWLEDGE";
export const GET_IMPACT = "GET_IMPACT";
export const GET_GOAL = "GET_GOAL";

// Knowledge
export const GET_KNOWLEDGE_MAP = "GET_KNOWLEDGE_MAP";
export const GET_KNOWLEDGE_COUNT = "GET_KNOWLEDGE_COUNT";
export const GET_KNOWLEDGE_COUNT_KN = "GET_KNOWLEDGE_COUNT_KN";
export const GET_KNOWLEDGE_COUNT_NEWKN = "GET_KNOWLEDGE_COUNT_NEWKN";
export const GET_KNOWLEDGE_CHART = "GET_KNOWLEDGE_CHART";

export const GET_KNOWLEDGE_RESULT = "GET_KNOWLEDGE_RESULT";
export const GET_NEWKNOWLEDGE_RESULT = "GET_NEWKNOWLEDGE_RESULT";
export const GET_INNOVATIONS_RESULT = "GET_INNOVATIONS_RESULT";

// Goal 
export const GET_GOAL_MAP = "GET_GOAL_MAP";
export const GET_GOAL_COUNT = "GET_GOAL_COUNT";
export const GET_GOAL_CHART = "GET_GOAL_CHART";

export const GET_BCG_RESULT = "GET_BCG_RESULT";
export const GET_SDGS_RESULT = "GET_SDGS_RESULT";
export const GET_CURVE_RESULT = "GET_CURVE_RESULT";
export const GET_CLUSTER_RESULT = "GET_CLUSTER_RESULT";

// Impact
export const GET_IMPACT_MAP = "GET_IMPACT_MAP";
export const GET_IMPACT_COUNT = "GET_IMPACT_COUNT";
export const GET_IMPACT_CHART = "GET_IMPACT_CHART";

export const GET_ECONOMY_RESULT = "GET_ECONOMY_RESULT";
export const GET_SOCIETY_RESULT = "GET_SOCIETY_RESULT";
export const GET_CULTURE_RESULT = "GET_CULTURE_RESULT";
export const GET_ENVIRONMENT_RESULT = "GET_ENVIRONMENT_RESULT";

// NewKnowledge
export const GET_NEWKNOWLEDGE_MAP = "GET_NEWKNOWLEDGE_MAP";
export const GET_NEWKNOWLEDGE_COUNT = "GET_NEWKNOWLEDGE_COUNT";
export const GET_NEWKNOWLEDGE_CHART = "GET_NEWKNOWLEDGE_CHART";


export const GET_RESULT_ONE = "GET_RESULT_ONE";

